export const exportTypes = {
  WEBM: 'webm',
  MP4: 'mp4'
};

export function getExportOptions() {

  const shapes = [{
    type: exportTypes.WEBM,
    name: 'WebM'
  }, {
    type: exportTypes.MP4,
    name: 'MP4'
  }];

  return shapes;

}